module.exports = __webpack_public_path__ + "static/media/promo-8.50a9d772.png";